export default __webpack_public_path__ + "static/media/2xcell_logo.c1897ea4.png";